var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGroup82151(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 308,
    height: 92,
    viewBox: "0 0 308 92",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8215",
    "data-name": "Group 8215",
    transform: "translate(-1612 -938)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_8214",
    "data-name": "Group 8214",
    transform: "translate(2691 -890) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_885",
    "data-name": "Rectangle 885",
    d: "M1,0H92a0,0,0,0,1,0,0V288a20,20,0,0,1-20,20H20A20,20,0,0,1,0,288V1A1,1,0,0,1,1,0Z",
    transform: "translate(1828 771)",
    fill: "#ed1c24"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_152",
    "data-name": "Ellipse 152",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1709 947)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_157",
    "data-name": "Ellipse 157",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1898 1010)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_154",
    "data-name": "Ellipse 154",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1803 1013)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_161",
    "data-name": "Ellipse 161",
    cx: 2.5,
    cy: 2.5,
    r: 2.5,
    transform: "translate(1889 947)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_153",
    "data-name": "Ellipse 153",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1640 1018)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_174",
    "data-name": "Ellipse 174",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1620 969)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_169",
    "data-name": "Ellipse 169",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1812 947)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_162",
    "data-name": "Ellipse 162",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1740 948)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_156",
    "data-name": "Ellipse 156",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1784 953)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_166",
    "data-name": "Ellipse 166",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1872 1018)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_168",
    "data-name": "Ellipse 168",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1881 1005)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_155",
    "data-name": "Ellipse 155",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1711 1011)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_159",
    "data-name": "Ellipse 159",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1700 953)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_172",
    "data-name": "Ellipse 172",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1653 999)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_175",
    "data-name": "Ellipse 175",
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "translate(1626 991)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_164",
    "data-name": "Ellipse 164",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1757 1020)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_163",
    "data-name": "Ellipse 163",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1675 1014)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_173",
    "data-name": "Ellipse 173",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1647 945)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_158",
    "data-name": "Ellipse 158",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1853 956)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_170",
    "data-name": "Ellipse 170",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1909 994)",
    fill: "#e7c16d"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_160",
    "data-name": "Ellipse 160",
    cx: 1,
    cy: 1,
    r: 1,
    transform: "translate(1910 959)",
    fill: "#e7c16d"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroup82151);
export default __webpack_public_path__ + "static/media/Group 8215 (1).2049cd8ed3f163f7a39bc0eac0fef44f.svg";
export { ForwardRef as ReactComponent };